export const prefixOptions = [
  { label: 'Frau', value: 'MS' },
  { label: 'Herr', value: 'MR' },
];

export const titleOptions = [
  { label: '', value: '' },
  { label: 'Dr.', value: 'DOCTOR' },
  { label: 'Prof.', value: 'PROFESSOR' },
  { label: 'Prof. Dr.', value: 'PROFESSOR_DOCTOR' },
];
